/**
 * Takes a bounding rect of a given element and returns the element absolute left
 * @param boundingRect
 * @returns {number}
 */
const getAbsoluteLeft = ({ left = 0 }) => left;

export default getAbsoluteLeft;
